import { Card } from '@/components/ui/card'
import AuthLayout from '../auth-layout'
import { UserAuthForm } from './components/user-auth-form'

export default function SignIn() {
  return (
    <AuthLayout>
      <Card className='p-6'>
        <div className='flex flex-col space-y-2 text-left'>
          <h1 className='text-2xl font-semibold tracking-tight'>Login</h1>
          <p className='text-sm text-muted-foreground'>
            Enter your email and password below <br />
            to log into your account
          </p>
        </div>

        <UserAuthForm />

        {/* <p className='mt-10 px-8 text-center text-sm text-muted-foreground'>
          By clicking login, you agree to our{' '}
          <span
          // href='/terms'
          // className='underline underline-offset-4 hover:text-primary'
          >
            Terms of Service
          </span>{' '}
          and{' '}
          <span
          // href='/privacy'
          // className='underline underline-offset-4 hover:text-primary'
          >
            Privacy Policy
          </span>
          .
        </p> */}
      </Card>
    </AuthLayout>
  )
}
